import { useEffect, useState } from 'react';

export function formatCountdown(expiresAt: string): string | null {
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return null;
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function useOfferCountdown(
  expiresAt: string | null | undefined,
  onExpired?: () => void,
): string | null {
  const [label, setLabel] = useState<string | null>(() =>
    expiresAt ? formatCountdown(expiresAt) : null,
  );

  useEffect(() => {
    if (!expiresAt) {
      setLabel(null);
      return;
    }

    const tick = () => {
      const next = formatCountdown(expiresAt);
      setLabel(next);
      if (!next) onExpired?.();
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [expiresAt, onExpired]);

  return label;
}
